import { render, staticRenderFns } from "./WithdrawalPolicy.vue?vue&type=template&id=19ae199c&scoped=true&"
var script = {}
import style0 from "./WithdrawalPolicy.vue?vue&type=style&index=0&id=19ae199c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae199c",
  null
  
)

export default component.exports